'use client';
import { useEffect, useState } from 'react';
import { isWindowDefined } from '@utils/validations';

const MOBILE_WIDTH = 640;
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(isWindowDefined ? window.innerWidth <= MOBILE_WIDTH : false);

  useEffect(() => {
    if (!isWindowDefined) {
      return;
    }

    function checkWindowSize() {
      setIsMobile(window.innerWidth <= MOBILE_WIDTH);
    }
    checkWindowSize();

    window.addEventListener('resize', checkWindowSize);

    return () => {
      window.removeEventListener('resize', checkWindowSize);
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
